import { jsx as l } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M8.173 2.761a10 10 0 1 1 7.654 18.478A10 10 0 0 1 8.173 2.761m7.534 7.946a1 1 0 0 0-1.414-1.414L11 12.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  i as default
};
